import {
  Box,
  Button,
  Card,
  Container,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import axios from 'axios';
import React, { useCallback, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import Iconify from '../components/Iconify';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
// import TopicForm from 'src/components/TopicForm';
import { baseUrl } from '../constant/config';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
import DebateForm from '../components/DebateForm';
import DebateRow from '../components/DebateRow';
// import DebateReqModal from 'src/components/DebateReqModal';

const style = {
  // position: 'absolute',
  // top: '50%',
  // left: '50%',
  // transform: 'translate(-50%, -50%)',
  width: 400,
  // bgcolor: 'background.paper',
  // border: '2px solid #000',
  // boxShadow: 24,
  p: 4,
};

function Debate() {
  const [editedDebate, setEditedDebate] = useState(null);
  const [open, setOpen] = useState(false);
  const [isView, setIsView] = useState(false);
  const queryClient = useQueryClient();

  const { data: debates, isSuccess } = useQuery(
    ['allDebtes'],
    async () => {
      const url = `${baseUrl}/api/admin/getDebates`;
      const { data } = await axios.get(url);
      return data.debates;
    },
    {
      // enabled: !!isAuth,
      // refetchOnWindowFocus: false,
      // refetchOnReconnect: false,
      refetchInterval: 10000
    }
  );

  // Replaces window.alert, which blocks the page and cannot show success
  // and failure differently.
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [toast, setToast] = useState(null);
  const notify = (message, severity = 'success') => setToast({ message, severity });

  const { mutate, isLoading: addDebateLoading } = useMutation(
    async (variables) => {
      const { data } = await axios.post(`${baseUrl}/api/admin/addDebate`, variables, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return data;
    },
    {
      onSuccess: (response) => {
        setOpen(false);
        queryClient.refetchQueries('allDebtes');
        notify(response?.msg || 'Debate created');
      },
      onError: (error) => {
        notify(error.response?.data?.msg || error.message, 'error');
      },
    }
  );

  const {
    mutate: editDebateMutate,
    // data: deleteData,
    isLoading: editRoleLoading,
  } = useMutation(
    async (variables) => {
      console.log(variables.formData);
      const { data } = await axios.post(`${baseUrl}/api/admin/editDebate/${variables.debateId}`, variables.formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return data;
    },
    {
      onSuccess: (d) => {
        queryClient.invalidateQueries('allDebtes');
        setEditedDebate(null);
        setOpen(false);
        notify(d?.msg || 'Debate updated');
      },
      onError: (error) => {
        notify(error.response?.data?.msg || error.message, 'error');
      },
    }
  );

  const {
    mutate: deleteTopic,
    isLoading: deleteRoleLoading,
    // The id being deleted, so only that row shows a spinner.
    variables: deletingId,
  } = useMutation(
    async (debateId) => {
      const { data } = await axios.delete(`${baseUrl}/api/admin/deleteDebate/${debateId}`);
      return data;
    },
    {
      onSuccess: (d) => {
        queryClient.invalidateQueries('allDebtes');
        notify(d?.msg || 'Debate deleted');
      },
      onError: (error) => {
        notify(error.response?.data?.msg || error.message, 'error');
      },
    }
  );

  // True while either the create or the update request is in flight.
  const saving = addDebateLoading || editRoleLoading;

  const handleOpen = () => {
    setEditedDebate(null);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handelEditDebate = useCallback((plan) => {
    setEditedDebate(plan);
    setOpen(true);
  }, []);

  const handelViewReqs = useCallback((plan) => {
    setEditedDebate(plan);
    setIsView(true);
  }, []);

  return (
    <Page title="Debate">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Debates
          </Typography>
          <Box sx={{ display: 'flex', gridGap: '10px' }}>
            <Button variant="contained" onClick={handleOpen} startIcon={<Iconify icon="eva:plus-fill" />}>
              New debate
            </Button>
          </Box>
        </Stack>
        <Card>
          <Scrollbar>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Start Date</TableCell>
                    <TableCell>Duration</TableCell>
                    <TableCell>Recording</TableCell>
                    <TableCell>Edit</TableCell>
                    {/* <TableCell>Requests</TableCell> */}
                    {/* <TableCell>Delete</TableCell> */}
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isSuccess &&
                    debates.map((row, i) => (
                      <DebateRow
                        inc={i}
                        key={i}
                        row={row}
                        count={debates.length}
                        handelEditDebate={handelEditDebate}
                        handelViewReqs={handelViewReqs}
                        deleteTopic={deleteTopic}
                        deletingId={deleteRoleLoading ? deletingId : null}
                        notify={notify}
                      />
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>{' '}
        {/* <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        > */}
        <Dialog
          open={open}
          // Closing mid-request would leave the caller with no feedback.
          onClose={saving ? undefined : handleClose}
          maxWidth="sm"
          fullWidth
          // Full screen on a phone; a bounded, scrolling panel everywhere else.
          fullScreen={smallScreen}
        >
          <DialogTitle sx={{ textAlign: 'center', pr: 6 }}>
            {!editedDebate ? 'Add new' : 'Edit'} debate
            <IconButton
              aria-label="Close"
              onClick={handleClose}
              // Same rule as the backdrop: do not abandon a request in flight.
              disabled={saving}
              sx={{ position: 'absolute', right: 8, top: 8, color: 'text.secondary' }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          {/* dividers gives the body its own scroll area, so a long form never
              pushes the submit button off the bottom of the screen. */}
          <DialogContent dividers>
            <DebateForm
              mutate={mutate}
              editedDebate={editedDebate}
              editDebateMutate={editDebateMutate}
              saving={saving}
            />
          </DialogContent>
        </Dialog>
        {/* </Modal> */}
        <Snackbar
          open={Boolean(toast)}
          autoHideDuration={5000}
          onClose={() => setToast(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert
            onClose={() => setToast(null)}
            severity={toast?.severity || 'success'}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {toast?.message}
          </Alert>
        </Snackbar>
        {/* <DebateReqModal isView={isView} setIsView={setIsView} style={style} editedDebate={editedDebate} /> */}
      </Container>
    </Page>
  );
}

export default Debate;
